import {Project} from "../api/Project";

export const arrowMateProject: Project = {
    id: 5,
    title: 'ArrowMate - The Meeting App',
    description: 'This project developed with aims to let the people meet any time, any where virtually, This application has the strongest algorithm to make the meeting more secure and have the features like chats, file sharing etc',
    link: '',
    image: '',
    startDate: 'April 2020',
    completeDate: undefined,
    hidden: true,
    technologies: {
        backend: [
            "Java",
            "Java FX",
            "Android"
        ],
        frontend: [
            "FXML",
            "FX-CSS"
        ]
    },
}